$(document).ready(function () {
 /* let carousel = $('.main-carousel');
   carousel.owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout:5000,
    animateOut: 'fadeItemOut',
    animateIn: 'fadeItemIn',
    margin: 30,
    dots: true,
   autoplayHoverPause:false,
    stagePadding:30,
    smartSpeed:450,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    }
  })

  carousel.on('change.owl.carousel', function (event) {
    event.preventDefault();

    console.log('Change triggered')
  })*/

 
  let config = {
  container: '.gallery-carousel',
  carouselClass: '.main-carousel',
  margin: 30,
  animationOutClass: 'fadeItemOut',
  animationInClass: 'fadeItemIn',
  duration: 500,
  autoplay: false,
  autoplayInterval: 5000,
  dots: true, // Disable dots (pagination)
  nav: true,
	navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  responsive: {
    0: { items: 2 },
    600: { items: 3 },
    1024: { items: 4 },
    1025: { items: 5 },
    1200: { items: 6 },
    5000: { items: 6 }
  }
}

   let carousel = $(config.carouselClass);
  

  let responsiveBreakPoints = config.responsive;

  let alternateItemsToShow =  carousel.attr('data-items-per-slide');
  let slideItems = carousel.find('.carousel-item');
  let switchInterval;


  if (alternateItemsToShow){
      responsiveBreakPoints[1024].items = parseInt(alternateItemsToShow);
  }

  function getBreakPoint(width) {
      let breakPoints = Object.keys(responsiveBreakPoints).map(key => parseInt(key));

    //console.log({ breakPoints })

    let breakPointItems =  responsiveBreakPoints[breakPoints[breakPoints.length-1]].items ;

    breakPoints.forEach((point, index) => {
      let lastIndex = index - 1 < 0 ? 0 : index - 1;

         if (width > breakPoints[lastIndex] && width < breakPoints[index]) {
           breakPointItems =  responsiveBreakPoints[breakPoints[lastIndex]].items 
          } else {
           if (width > breakPoints[index] && index === breakPoints.length-1){  
             breakPointItems = responsiveBreakPoints[breakPoints[index]].items
           }
          } 
    })

    return breakPointItems

  }

  function getMaxSlides() {
    let slideObjects =  carousel.find('.carousel-item').length;
     let breakPointItems = getBreakPoint($(window).width());
    let slideExtras = slideObjects % breakPointItems !== 0 ? 1 : 0;
    let slides =  Math.floor( slideObjects / breakPointItems) + slideExtras;

    return slides
  }

  let activeIndex = 0;
 // console.log({ responsiveBreakPoints })
  function setWidthAndMargins() {
    let items = Array.from(slideItems);
    let breakPointItems = getBreakPoint($(window).width());

    let startIndex = items.length % breakPointItems;
    let missingItems = breakPointItems - startIndex;

    /*if (missingItems > 0) {
      
        let position = Math.round(items.length / breakPointItems);
        startIndex = (startIndex * position) + (breakPointItems % 2);
        breakPoint = breakPointItems * position;
        let clonedItems = items.slice(startIndex, breakPoint)
      // console.log({ clonedItems, missingItems, startIndex, breakPoint })
      clonedItems = clonedItems.map(item => {    
        item = item.cloneNode(true)
        item.classList.add('cloned');

        return item
      })
        let completeItems = [...items.slice(0, breakPoint), ...clonedItems, ...items.slice(breakPoint)]
       // console.log({ breakPointItems, items: items.length, missingItems, clonedItems, completeItems })

        carousel.html("");

        completeItems.forEach(item => {
        
          carousel.append(item)
        })

      items = completeItems
    //  console.log({ items: items.length })

    //  slideItems = carousel.find('.carousel-item');
    }*/
    items.forEach((item, index) => {
     // let width = `calc(${Math.floor(100 / breakPointItems)}% - ${ breakPointItems === 1 ? 0 : config.margin / 1.85}px)`;
        let marginOffset = breakPointItems === 1 ? 0 : config.margin;
        let parentWidth = carousel.parent().width();
        let width = ((parentWidth - (config.margin * (breakPointItems - 1))) / breakPointItems);

        item.style.width = `${width}px`;
        let positionIndex = index < breakPointItems ? index : index % breakPointItems;
        let offset =  config.margin * positionIndex ; 
       
        item.style.left = `${(width * positionIndex) + ( offset )}px`

      item.classList.remove('active')
      item.classList.remove('inactive')
      let activeClass = Math.floor( index / breakPointItems ) === activeIndex ? 'active' : 'inactive'

      item.classList.add(activeClass)
    })

      let slideObjects =  carousel.find('.carousel-item').length;
      let slides = getMaxSlides();
   

    if (slideObjects > breakPointItems){
      console.log(slides, slideObjects)
     $(".gallery-carousel .dots").remove();

      $(".gallery-carousel").append('<div class="dots"></div>')
      let dots = new Array(slides).fill('').forEach((dot, index) => {
        $(".gallery-carousel .dots").append(`<button class="${index == activeIndex ? 'active': ''}"><span></span></button>`)
      })
    }

  }


  function autoTransition() {
   // console.log({ interval: config.autoplayInterval })
    if (switchInterval) {
      clearTransition()
    }
     switchInterval = window.setInterval(() => {
      let maxSlides = getMaxSlides()
      activeIndex = activeIndex + 1 >= maxSlides ? 0 : activeIndex + 1;
       $('.dots button').removeClass('active');
        $('.dots button').eq(activeIndex).addClass('active')
      transitionSlides()
    }, config.autoplayInterval)
  }
  
  function clearTransition () {
    window.clearInterval(switchInterval)
  }
  
   function transitionSlides() {
      let items = Array.from(carousel.find('.carousel-item'));
     let itemsPerSlide = getBreakPoint($(window).width())
     clearTransition()

     // console.log({ items: items.length })

        items.forEach(item => {
          if (item.classList.contains('active')) {
            item.classList.add(config.animationOutClass)
          }
        })
      setTimeout(() => {
        
          items.forEach((item) => {
            item.classList.remove('active');
            item.classList.add('inactive');
        })

        items.forEach((item, itemIndex) => {
           let positionIndex = Math.floor( itemIndex / itemsPerSlide );

        

            if (positionIndex === activeIndex)  {
            //  console.log({ positionIndex })
                item.classList.remove('inactive');
                item.classList.add('active');

                item.classList.add(config.animationInClass)
            } 
        })

              setTimeout(() => {
                items.forEach(item => {
                   item.classList.remove(config.animationOutClass)
                   item.classList.remove(config.animationInClass)
                })
                autoTransition()
              }, config.duration)
      }, config.duration / 2)
  }
  $(config.container).addClass('activated')
  setWidthAndMargins();

  $(document).on('click', ".dots button", function () {
    let parent = $(this).parent().parent();
    let index = parent.find('.dots button').index(this);
    let itemsPerSlide = getBreakPoint($(window).width())
    let startIndex = index === 0 ? 0 : slideItems.length % (index * itemsPerSlide) - 1;
    let stopIndex = startIndex + (itemsPerSlide);

    if (activeIndex !== index){
       activeIndex = index;
      
      parent.find('.dots button').removeClass('active');
      $(this).addClass('active')
      
      transitionSlides()
    } 

   
  })
  $(window).on('resize', function () {
     setTimeout(() => {
          let width = $(this).width()
       // console.log({ width })
        activeIndex = 0;
        setWidthAndMargins()
     }, 100)
  })
  
  if (config.autoplay){
   autoTransition()   
  }

  carousel.on('mouseenter', function () {
    clearTransition()
  })

  carousel.on('mouseleave', function () {
    autoTransition()
  })
})